import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MemberDto } from '../../../service/dto';
import { HttpMemberService } from '../../../service/http-member.service';

@Component({
	selector: 'app-member-view',
	standalone: false,
	templateUrl: './member-view.component.html',
	styleUrls: ['./member-view.component.scss']
})
export class MemberViewComponent implements OnInit {
	member?: MemberDto;
	loading = false;
	error?: string;

	constructor(
		private route: ActivatedRoute,
		private memberService: HttpMemberService
	) { }

	ngOnInit(): void {
		const memberId = this.route.snapshot.paramMap.get('memberId');
		if (memberId) {
			this.loadMember(+memberId);
		} else {
			this.error = 'No member ID provided in route.';
		}
	}

	private loadMember(id: number): void {
		this.loading = true;
		this.memberService.getFull(id).subscribe(result => {
			this.member = result;
			this.loading = false;
		});
	}
}
